/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Location from './Location/index'
import Method from './Method/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/AddMethod/Content",
  method,
  locationId,
  person,
  amount,
  onPaymentPageCallback,
  reusableForBluefin
  
}) {
  return (<React.Fragment
>
<Location
  viewPath={`${viewPath}/Location`}
/>
<Method
  viewPath={`${viewPath}/Method`}
 method={method}
 locationId={locationId}
 person={person}
 amount={amount}
 onPaymentPageCallback={onPaymentPageCallback}
 reusableForBluefin={reusableForBluefin}
/>
{children}
</React.Fragment>)
}